<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png">  
    <!-- <router-link to="/about">helloword</router-link> -->
  </div>
</template>

<script> 

export default {
  name: 'Home', 
}
</script>
